export const countdown = (s) => {
  const d = Math.floor(s / (3600 * 24));
  s  -= d * 3600 * 24;
  const h = Math.floor(s / 3600);
  s  -= h * 3600;
  const m = Math.floor(s / 60);
  s  -= m * 60;
  const tmp = [];
  const daysPassed = ` ${d} ימים `;
  const hoursPassed = `${h} שעות `;
  const minutesPassed = `${m} דקות `;
  (d) && tmp.push(daysPassed);
  (d || h) && tmp.push(hoursPassed);
  (d || h || m) && tmp.push(minutesPassed);
  return tmp.join(' ');
}
